import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { Linkedin, MessagesSquare, Send, Plug } from 'lucide-react';
import LinkedInConversations from './LinkedInConversations';
import LinkedInOutbox from './LinkedInOutbox';
import LinkedInExtensionSetup from './LinkedInExtensionSetup';

const VALID_TABS = ['conversations', 'queue', 'setup'];

export default function LinkedInWorkspace() {
  const params = new URLSearchParams(window.location.search);
  const initial = VALID_TABS.includes(params.get('tab')) ? params.get('tab') : 'conversations';
  const [tab, setTab] = useState(initial);

  const onTab = (v) => {
    setTab(v);
    const p = new URLSearchParams(window.location.search);
    p.set('tab', v);
    if (v !== 'conversations') p.delete('lead');
    window.history.replaceState(null, '', `${window.location.pathname}?${p.toString()}`);
  };

  return (
    <div className="space-y-5" data-testid="linkedin-workspace-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Linkedin className="h-6 w-6 text-[#0a66c2]" />LinkedIn
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          One workspace for conversations, the outbound queue & extension setup
        </p>
      </div>

      <Tabs value={tab} onValueChange={onTab}>
        <TabsList className="grid w-full grid-cols-3 sm:w-auto sm:inline-flex" data-testid="li-workspace-tabs">
          <TabsTrigger value="conversations" className="gap-1.5" data-testid="li-tab-conversations">
            <MessagesSquare className="h-4 w-4" />Conversations
          </TabsTrigger>
          <TabsTrigger value="queue" className="gap-1.5" data-testid="li-tab-queue">
            <Send className="h-4 w-4" />Queue
          </TabsTrigger>
          <TabsTrigger value="setup" className="gap-1.5" data-testid="li-tab-setup">
            <Plug className="h-4 w-4" />Setup
          </TabsTrigger>
        </TabsList>

        <TabsContent value="conversations" className="mt-4">
          <LinkedInConversations embedded />
        </TabsContent>
        <TabsContent value="queue" className="mt-4">
          <LinkedInOutbox embedded />
        </TabsContent>
        <TabsContent value="setup" className="mt-4">
          <LinkedInExtensionSetup embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
